<template lang="html">
  <div class="order-info-list">
    <div class="order-info-title pf-medium">订单信息</div>
    <div class="price" v-if="product.Id">
      <PriceStep
        :product="product"
        :order="order"
        v-if="isStepOrder"
      ></PriceStep>
      <PriceCommon :product="product" :order="order" v-else></PriceCommon>
    </div>
    <div class="devider"></div>
    <div>
      <div class="item-cell">
        <div class="item-cell-hd">订单编号：</div>
        <div class="item-cell-bd">
          <span id="success_form_input">{{ order.orderId }}</span
          ><button
            @click="copyOrderId"
            ref="copy"
            :data-clipboard-text="order.orderId"
            data-clipboard-target="#success_form_input"
            class="copyText"
          >
            复制
          </button>
        </div>
        <!-- <div class="item-cell-ft refund-detail" v-if="order.refundState === 20 && order.payType == 2">
                    <router-link :to="`/order/payment/${order.orderId}?cmd=share&sharetype=0&refresh=no&type=2`">
                        <span>查看退款凭证</span><i class="iconfont icon-youjiantou"></i>
                    </router-link>
                </div> -->
      </div>
      <div class="item-cell">
        <div class="item-cell-hd">下单时间：</div>
        <div class="item-cell-bd">
          {{ $$dateFormat(order.orderCreateTime, 'YY.MM.DD hh:mm:ss') }}
        </div>
      </div>
      <div class="item-cell">
        <div class="item-cell-hd">订单状态：</div>
        <div class="item-cell-bd">
          {{ synthesisStateDesc }}
        </div>
        <!-- <div class="item-cell-ft refund-detail" v-if="order.orderState===20 && order.refundState !== 10">
                    <router-link :to="`/order/${order.orderId}/refund`">
                        <span>退款详情</span><i class="iconfont icon-youjiantou"></i>
                    </router-link>
                </div> -->
      </div>
      <div class="item-cell" v-if="remark">
        <div class="item-cell-hd">备注:</div>
        <div class="item-cell-bd">
          <div class="remark">
            <p>{{ remark ? remark : '无' }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 仅实物商品展示联系商家模块  -->
    <div v-if="hasTelShop && order.businessMobile">
      <div class="devider2"></div>
      <a :href="`tel:${order.businessMobile}`">
        <div class="tel-shop"><i class="telimg"></i><span>联系商家</span></div>
      </a>
    </div>
  </div>
</template>

<script>
import PriceCommon from './price/price-common'
import PriceStep from './price/price-step'

import { E_SKUTAG, ORDER_STATE_ENUM } from '@/config'
import { mapState } from 'vuex'
import mixProm from '@/mixin/mixProm'
export default {
  components: {
    PriceCommon,
    PriceStep
  },
  mixins: [mixProm],
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    orderStatus: {
      type: Number,
      default: -1
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    synthesisStateDesc: {
      type: String,
      default: ''
    },
    state: {
      type: Number,
      default: -1
    },
    remark: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isPendingPayment: this.order.orderState == ORDER_STATE_ENUM.PENDING_PAY
    }
  },
  mounted() {
    this.copyBtn = new this.$$clipboard(this.$refs.copy)
  },
  computed: {
    ...mapState(['selectedCoupon']),
    hasTelShop() {
      // 是否pop实物
      const { skuTag } = this.order
      return skuTag == E_SKUTAG.POPENTITY || skuTag == E_SKUTAG.UNIONHOME
    }
  },
  methods: {
    copyOrderId() {
      let _this = this
      let clipboard = _this.copyBtn
      clipboard.on('success', function (e) {
        _this.$$toast('复制成功')
        return
      })
      clipboard.on('error', function (e) {
        window.prompt('复制失败，请手动复制', e.text)
      })
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-info-list {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background: #fff;
  padding: rem(32px) 0 rem(16px) 0;

  .order-info-title {
    font-size: rem(30px);
    padding: 0 0 0 rem(24px);
  }

  .copyText {
    font-size: rem(26px);
    color: #ff5900;
    line-height: rem(32px);
    margin-left: rem(19px);
  }

  .item-cells {
    padding: rem(44px) 0 rem(20px);
    border-radius: rem(16px);
  }
  .item-cell {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 0;
    font-size: rem(26px);
    color: #262626;
    line-height: rem(32px);

    .item-cell-hd {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
    }

    .item-cell-bd {
      font-weight: 500;
      font-size: rem(26px);
      color: #121212;
      line-height: rem(32px);
      text-align: right;
    }
  }

  .tel-shop {
    text-align: center;
    font-size: rem(26px);
    padding: rem(32px) 0 rem(16px) 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .telimg {
      display: inline-block;
      width: rem(28px);
      height: rem(28px);
      background: url('../../assets/images/order/icon-tel4.png') center center;
      background-size: rem(28px) rem(28px);
      margin-right: rem(10px);
    }
  }
}
.price-total {
  margin-top: rem(21px);

  .item-cell-bd {
    text-align: right;
  }
  .actual-pay {
    .item-cell-bd {
      color: #ff5900;
    }
  }
}
.refund-detail {
  .iconfont {
    vertical-align: middle;
  }
}

.remark {
  word-wrap: break-word;
  word-break: break-word;
  display: flex;
  justify-content: flex-end;
  p {
    max-width: rem(526px);
  }
}

.devider {
  background: #ededed;
  height: rem(1px);
  margin: 0 rem(24px) rem(32px) rem(24px);
}

.devider2 {
  background: #ededed;
  height: rem(1px);
  margin: 0 rem(24px) 0 rem(24px);
}
</style>
